/**
 * Formats a site's address components into a human-readable string.
 * Handles both US and international addresses with appropriate formatting.
 *
 * @param {Object} site - The site object containing address information
 * @param {string} site.address - Street address
 * @param {string} site.city - City name
 * @param {string} site.country - Country name
 * @param {string} site.state - State/Province name (optional for non-US)
 * @param {string} site.postalCode - Postal/Zip code
 * @returns {string} Formatted address string
 */
export const getSiteAddress = (site) => {
  const { address, city, country, state, postalCode } = site;
  
  // Format address components
  const street = address ? `${address}, ` : '';
  const cityPart = city ? `${city}, ` : '';
  const statePart = country === 'US' && state ? `${state}, ` : '';
  const countryPart = country !== 'US' ? `${country}, ` : '';
  const postalCodePart = postalCode ? `${postalCode}` : '';
  
  // Combine all parts
  const addressParts = [street, cityPart, statePart, countryPart, postalCodePart];
  
  // Remove trailing comma and space if present
  const formattedAddress = addressParts.join('').replace(/, $/, '');
  
  return formattedAddress;
};
